import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { contactUsActions } from "redux/actions/ContactUsActions/contactUsActions";
import { useTranslation } from "react-i18next";
import { RootState } from "redux/rootReducer";

interface contactUsTypes {
  firstName: string;
  lastName: string;
  email: string;
  phone: number;
  countryCode: any;
  message: string;
}

const useContactUsFormik = (country: any) => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const { userId } = useSelector((state: RootState) => state.loginReducer);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      countryCode: "",
      phone: 0,
      message: "",
    },

    validationSchema: yup.object({
      firstName: yup.string().required(`${t("This field is required")}`),
      lastName: yup.string().required(`${t("This field is required")}`),
      email: yup
        .string()
        .email()
        .required(`${t("This field is required")}`),

      phone:
        country === "eg"
          ? yup
              .string()
              .matches(
                /^(?:\+20|0)?(10|11|12|15)\d{8}$/,
                `${t("Invalid phone number")}`
              )
              .required(`${t("This field is required")}`)
          : country === "uae"
          ? yup
              .string()
              .matches(
                /^(?:\+971|0)?(50|55|56|52|58)\d{7}$/,
                `${t("Invalid phone number")}`
              )
              .required(`${t("This field is required")}`)
          : yup.string().required(`${t("This field is required")}`),
      message: yup.string().required(`${t("This field is required")}`),
    }),

    onSubmit: async (values: contactUsTypes) => {
      dispatch(
        contactUsActions(
          {
            priority_type: null, // null, high
            feedback_type: "suggestion", //suggestion OR bug_report OR general_feedback
            rating_value: null, // null, 1, 2, 3, 4, 5
            first_name: values.firstName,
            last_name: values.lastName,
            email_address: values.email,
            phone_number: values.phone,
            message: values.message,
          },
          userId ?? 0
        )
      );
    },
  });

  return formik;
};

export { useContactUsFormik };
